__turbopack_context__.v({
  "actionBtn": "brands-module__-xDcZW__actionBtn",
  "container": "brands-module__-xDcZW__container",
  "dataItem": "brands-module__-xDcZW__dataItem",
  "dataSummary": "brands-module__-xDcZW__dataSummary",
  "deleteBtn": "brands-module__-xDcZW__deleteBtn",
  "emptyState": "brands-module__-xDcZW__emptyState",
  "error": "brands-module__-xDcZW__error",
  "formats": "brands-module__-xDcZW__formats",
  "header": "brands-module__-xDcZW__header",
  "historyCard": "brands-module__-xDcZW__historyCard",
  "icon": "brands-module__-xDcZW__icon",
  "importActions": "brands-module__-xDcZW__importActions",
  "importContent": "brands-module__-xDcZW__importContent",
  "importCount": "brands-module__-xDcZW__importCount",
  "importFilename": "brands-module__-xDcZW__importFilename",
  "importIcon": "brands-module__-xDcZW__importIcon",
  "importId": "brands-module__-xDcZW__importId",
  "importItem": "brands-module__-xDcZW__importItem",
  "importMeta": "brands-module__-xDcZW__importMeta",
  "importStatus": "brands-module__-xDcZW__importStatus",
  "importsList": "brands-module__-xDcZW__importsList",
  "sampleBtn": "brands-module__-xDcZW__sampleBtn",
  "searchBox": "brands-module__-xDcZW__searchBox",
  "searchInput": "brands-module__-xDcZW__searchInput",
  "searchSection": "brands-module__-xDcZW__searchSection",
  "statBadge": "brands-module__-xDcZW__statBadge",
  "stats": "brands-module__-xDcZW__stats",
  "statusBadge": "brands-module__-xDcZW__statusBadge",
  "subtitle": "brands-module__-xDcZW__subtitle",
  "success": "brands-module__-xDcZW__success",
  "title": "brands-module__-xDcZW__title",
  "titleRow": "brands-module__-xDcZW__titleRow",
  "uploadArea": "brands-module__-xDcZW__uploadArea",
  "uploadBtn": "brands-module__-xDcZW__uploadBtn",
  "uploadCard": "brands-module__-xDcZW__uploadCard",
  "uploadIcon": "brands-module__-xDcZW__uploadIcon",
  "uploadStatus": "brands-module__-xDcZW__uploadStatus",
  "uploading": "brands-module__-xDcZW__uploading",
  "viewBtn": "brands-module__-xDcZW__viewBtn",
});
